export default __webpack_public_path__ + "static/media/hm-pop-img.3f3cad80.webp";